import { RichText } from '@wordpress/block-editor';
import BlockContext from "../context/blockContext";
import SectionItemContext from "../context/sectionItemContext";
import { useContext } from "@wordpress/element";
const  Skills = () => {
  const { updateField } = useContext(BlockContext);
  const { item, index, itemIndex } = useContext(SectionItemContext);
  return (
   <div className="cv-skill">
        {
            (item.name || item.percentage) && (
                <div className="bwdcv-pb-area">
                    <div className="bwdcv-pb-name">
                        <div className="bwdcv-pb-label">
                        <RichText
                            tagName="span"
                            value={item.name}
                            onChange={(value) => updateField(index, "name", value, itemIndex)}
                        />
                        </div>
                        <div className="bwdcv-progress-bar">
                        <span className="bwdcv-percentage-counter">0%</span>
                        <div className="bwdcv-per-val" data-pb-val={item.percentage}></div>
                        </div>
                    </div>
                </div>

            )
        }
    </div>
  )
}

export default Skills
